module.exports = __webpack_public_path__ + "img/description-icon.280eca92.svg";